import { ArrowLongRightIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';
import PageContainer from '../components/page-container/PageContainer';
import PageTitle from '../components/PageTitle';
import StartNavbar from '../components/start-navbar/StartNavbar';
import InvitationsTable from '../features/invitations/InvitationsTable';

function InvitationsPage(): JSX.Element {
    return (
        <>
            <StartNavbar />
            <PageContainer>
                <div className="pb-4">
                    <div className="pb-4 border-b">
                        <PageTitle title="Firm Invitations" />
                    </div>
                    <p className="text-sm text-gray-500 max-w-[80ch] my-8">
                        You can view your pending invitations below or from the bell icon in the top-right corner. If you don&apos;t see an
                        invitation, you can ask your firm&apos;s administrator to invite you.
                    </p>
                    <InvitationsTable />
                    <Link
                        to="/start/setup"
                        className="text-sm text-indigo-600 font-medium flex items-center gap-2 hover:text-indigo-700 mt-4"
                    >
                        Or create a firm <ArrowLongRightIcon className="h-5 w-5" />
                    </Link>
                </div>
            </PageContainer>
        </>
    );
}
export default InvitationsPage;
